import "../icon.styles.css";

const JSIcon = ({ width, height }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 250 250"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g
        id="Frame 1"
        clip-path="url(#clip0_1_2)">
        <path
          className="highlight"
          id="icon"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0V249.664H249.664V0H0ZM181.992 202.144C170.944 202.144 165.728 194.676 160.93 186.88L143.328 198.567C149.902 211.487 161.713 221.923 182.511 221.923C203.775 221.923 219.614 210.932 219.614 190.875C219.614 172.262 208.878 163.98 189.842 155.874L184.245 153.488C174.64 149.348 170.479 146.643 170.479 139.958C170.479 134.548 174.633 130.408 181.194 130.408C187.622 130.408 191.77 133.105 195.605 139.958L213.039 128.813C205.661 115.9 195.431 110.969 181.194 110.969C161.199 110.969 148.404 123.687 148.404 140.401C148.404 158.537 159.148 167.122 175.299 173.975L180.895 176.36C191.105 180.806 196.139 183.516 196.139 191.152C196.139 197.533 191.271 202.144 181.992 202.144ZM97.0914 198.567C89.4213 198.567 84.0882 193.733 80.5791 187.449L62.416 198.567C67.6728 209.815 80.5721 221.923 98.4433 221.923C118.223 221.923 131.767 211.299 131.767 187.948V110.962H108.653V184.398C108.653 195.668 104.429 198.567 97.0914 198.567Z"
          fill="#DEF7FF"
        />
      </g>
      <defs>
        <clipPath id="clip0_1_2">
          <rect
            width="250"
            height="250"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default JSIcon;
